import { render, staticRenderFns } from "./BsButtonContent.vue?vue&type=template&id=0f23979a&"
import script from "./BsButtonContent.vue?vue&type=script&lang=js&"
export * from "./BsButtonContent.vue?vue&type=script&lang=js&"
import style0 from "./BsButtonContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports